import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ParteMantenimientoService {

  private apiUrl =  `${environment.apiUrl}/api/parte_mantenimiento`; 
  //private apiUrl = 'http://localhost:3000/api/parte_mantenimiento'; // Ajusta el puerto si es diferente

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token') || '';
    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, { headers: this.getHeaders() });
  }

  create(parte: any): Observable<any> {
    return this.http.post(this.apiUrl, parte, { headers: this.getHeaders() });
  }

  update(id: number, parte: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, parte, { headers: this.getHeaders() });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { headers: this.getHeaders() });
  }
}